import React from "react";
import { motion } from "framer-motion";

import { styles } from "../styles";
import { SectionWrapper } from "../hoc";
import { fadeIn, textVariant } from "../utils/motion";
import { testimonials } from "../constants";

const FeedbackCard = ({ index, name, image }) => (
  <motion.div
    variants={fadeIn("", "spring", index * 0.1 + 0.3, 0.7)}
    className="w-full max-w-[720px] overflow-hidden rounded-2xl bg-black-200 p-3"
  >
    <img
      src={image}
      alt={name}
      className="h-auto w-full rounded-xl object-contain"
      loading="lazy"
    />
  </motion.div>
);

const Feedbacks = () => {
  return (
    <div style={{ marginTop: "-120px" }} className={`rounded-[20px] bg-black-100`}>
      <div
        className={`rounded-2xl bg-tertiary ${styles.padding} min-h-[300px]`}
      >
        <motion.div variants={textVariant()}>
          <p className={styles.sectionSubText}>What others say</p>
          <h2 className={styles.sectionHeadText}>Testimonials.</h2>
        </motion.div>
      </div>
      <div
        className={`-mt-20 pb-14 ${styles.paddingX} flex-center-center flex-wrap gap-7`}
      >
        {testimonials.map((testimonial, index) => (
          <FeedbackCard key={testimonial.name} index={index} {...testimonial} />
        ))}
      </div>
    </div>
  );
};

export default SectionWrapper(Feedbacks, "feedbacks");
